import BaseInventoryName from './BaseInventoryName';
import ItemName from './ItemName';

export default ItemName;
export { ItemName, BaseInventoryName };
